module.exports = __webpack_public_path__ + "static/media/pie-chart-race.82e88a35.svg";